var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"nlp__button",class:{
    'nlp__button--primary': _vm.primary,
    'nlp__button--primary-small': _vm.primarySmall,
    'nlp__button--secondary': _vm.secondary,
    'nlp__button--tertiary': _vm.tertiary,
    'nlp__button--fullwidth': _vm.fullWidth,
    'nlp__button--disabled': _vm.disabled,
  },attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }